import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Diamond02 = function Diamond02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M5.0003 22h14m-16.5-14h19m-11.5-6-2 6 4 10.5 4-10.5-2-6m-1.408 16.3489 8.9396-9.8336c.166-.1827.2491-.274.2821-.378a.5.5 0 0 0 .0061-.2825c-.0285-.1053-.1076-.2001-.2656-.3898l-4.3143-5.177c-.0882-.1059-.1322-.1588-.1863-.1968a.5.5 0 0 0-.1579-.074C16.8322 2 16.7634 2 16.6256 2H7.375c-.1377 0-.2066 0-.2704.0172a.5.5 0 0 0-.1578.074c-.054.038-.0982.0908-.1863.1967L2.4462 7.465c-.158.1896-.237.2845-.2657.3898a.5.5 0 0 0 .0061.2825c.0331.104.1161.1953.2822.378l8.9396 9.8336c.2052.2257.3078.3386.4284.3803a.5.5 0 0 0 .3271 0c.1206-.0417.2232-.1546.4284-.3803"
    })
  }));
};
export default Diamond02;